// src/hooks/useLoyalty.js
import { useState, useEffect, useCallback } from "react";
import loyaltyService from "@/services/loyaltyService";

export default function useLoyalty() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const fetchConfig = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await loyaltyService.getConfig();

      // 🔴 IMPORTANT: backend must return full object
      if (!data) {
        throw new Error("Loyalty program not configured");
      }

      setConfig(data);
      return data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const saveConfig = useCallback(async (payload) => {
    setSaving(true);
    setError(null);
    try {
      const updated = await loyaltyService.updateConfig(payload);
      setConfig(updated);
      return updated;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setSaving(false);
    }
  }, []);

  useEffect(() => {
    fetchConfig().catch(() => {});
  }, [fetchConfig]);

  return {
    config,
    loading,
    saving,
    error,
    fetchConfig,
    saveConfig,
  };
}
